import {useMemo} from 'react';
import {useInfiniteQuery} from 'react-query';
import reactQueryKeys from 'helpers/reactQueryKeys';
import {getAPIWithFilters} from 'data.api';
import {employeeAppliedJobs} from 'api_urls';

export const useJobboardAppliedList = () => {
  const {
    isLoading,
    isError,
    refetch,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    data,
  } = useInfiniteQuery(
    [
      reactQueryKeys.ALL_APPLIED_LIST,
      {
        limit: 10,
      },
    ],
    ({pageParam = 0, queryKey}) => {
      return getAPIWithFilters(
        {
          ...queryKey[1],
          offset: pageParam,
        },
        employeeAppliedJobs,
      );
    },
    {
      onSettled: (...args) => {
        // console.log({args});
      },
      cacheTime: 2 * 60 * 1000,
      staleTime: 2 * 60 * 1000,
      // enabled: conditionForEnabled,
      getNextPageParam: (lastPage, pages) => {
        if (
          !lastPage ||
          lastPage.data?.pagination?.to >= lastPage.data?.pagination?.total ||
          !lastPage.data?.pagination?.next
        )
          return;
        return lastPage.data?.pagination?.to;
      },
    },
  );

  const jobboardAppliedList = useMemo(() => {
    return (data?.pages || []).reduce(
      (list, p) => list.concat(p.data?.appliedJobs || []),
      [],
    );
  }, [data]);

  return {
    isLoading,
    data,
    jobboardAppliedList,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
  };
};
